import { GlobalAxios } from "./../axios/axios-config";
import {
  INewAppointmentArrival,
  IAppointmentArrival,
} from "../models/appointment-arrival";
import { ISelectType } from "@4uhub/lib4uhub";

const APPOINTMENT_ARRIVAL_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/AppointmentArrivalRule/";

export const createAppointmentArrival = (item: INewAppointmentArrival) => {
  return GlobalAxios.post(APPOINTMENT_ARRIVAL_ROUTE, item);
};

export const getAppointmentArrivalById = (id: string) => {
  return GlobalAxios.get<IAppointmentArrival>(APPOINTMENT_ARRIVAL_ROUTE + id);
};

export const updateAppointmentArrivalById = ({
  item,
  id,
}: {
  item: INewAppointmentArrival;
  id: string;
}) => {
  return GlobalAxios.put(APPOINTMENT_ARRIVAL_ROUTE + id, item);
};

export const appointmentArrivalList = (params: any) => {
  return GlobalAxios.get<ISelectType[]>(APPOINTMENT_ARRIVAL_ROUTE + "list", {
    params,
  });
};
